import { StrainAttributes } from "custom-types/Strain";

import { moveObjToSortedArray } from "./moveObjToSortedArray";

export const extractStrainSensations = (
  sensations: StrainAttributes,
  sort = "score"
) =>
  moveObjToSortedArray(sensations, sort).filter((effect) => effect.votes > 0);
